export const enum albumBuilderConstants {
    fetchTemplateRequest = "ALBUM_BUILDER_FETCH_TEMPLATE_REQUEST",
    fetchTemplateSuccess = "ALBUM_BUILDER_FETCH_TEMPLATE_SUCCESS",
    fetchTemplateFailure = "ALBUM_BUILDER_FETCH_TEMPLATE_FAILURE",

    createTemplateRequest = "ALBUM_BUILDER_CREATE_TEMPLATE_REQUEST",
    createTemplateSuccess = "ALBUM_BUILDER_CREATE_TEMPLATE_SUCCESS",
    createTemplateFailure = "ALBUM_BUILDER_CREATE_TEMPLATE_FAILURE",
    createTemplateRedirect = "ALBUM_BUILDER_CREATE_TEMPLATE_REDIRECT",

    updateTemplateRequest = "ALBUM_BUILDER_UPDATE_TEMPLATE_REQUEST",
    updateTemplateSuccess = "ALBUM_BUILDER_UPDATE_TEMPLATE_SUCCESS",
    updateTemplateFailure = "ALBUM_BUILDER_UPDATE_TEMPLATE_FAILURE",

    listTemplatesRequest = "ALBUM_BUILDER_LIST_TEMPLATES_REQUEST",
    listTemplatesSuccess = "ALBUM_BUILDER_LIST_TEMPLATES_SUCCESS",
    listTemplatesFailure = "ALBUM_BUILDER_LIST_TEMPLATES_FAILURE",

    fetchPageRequest = "ALBUM_BUILDER_FETCH_PAGE_REQUEST",
    fetchPageSuccess = "ALBUM_BUILDER_FETCH_PAGE_SUCCESS",
    fetchPageFailure = "ALBUM_BUILDER_FETCH_PAGE_FAILURE",


    createPageRequest = "ALBUM_BUILDER_CREATE_PAGE_REQUEST",
    createPageSuccess = "ALBUM_BUILDER_CREATE_PAGE_SUCCESS",
    createPageFailure = "ALBUM_BUILDER_CREATE_PAGE_FAILURE",

    deletePageRequest = "ALBUM_BUILDER_DELETE_PAGE_REQUEST",
    deletePageSuccess = "ALBUM_BUILDER_DELETE_PAGE_SUCCESS",
    deletePageFailure = "ALBUM_BUILDER_DELETE_PAGE_FAILURE",

    reorderPagesRequest = "ALBUM_BUILDER_REORDER_PAGES_REQUEST",
    reorderPagesSuccess = "ALBUM_BUILDER_REORDER_PAGES_SUCCESS",
    reorderPagesFailure = "ALBUM_BUILDER_REORDER_PAGES_FAILURE",

    nodeMutationRequest = "ALBUM_BUILDER_NODE_MUTATION_REQUEST",
    nodeMutationSuccess = "ALBUM_BUILDER_NODE_MUTATION_SUCCESS",
    nodeMutationFailure = "ALBUM_BUILDER_NODE_MUTATION_FAILURE",

    addNodeRequest = "ALBUM_BUILDER_ADD_NODE_REQUEST",
    addNodeSuccess = "ALBUM_BUILDER_ADD_NODE_SUCCESS",
    addNodeFailure = "ALBUM_BUILDER_ADD_NODE_FAILURE",

    removeNodeRequest = "ALBUM_BUILDER_REMOVE_NODE_REQUEST",
    removeNodeSuccess = "ALBUM_BUILDER_REMOVE_NODE_SUCCESS",
    removeNodeFailure = "ALBUM_BUILDER_REMOVE_NODE_FAILURE",

    setMode = "ALBUM_BUILDER_SET_MODE",
    historySelected= "ALBUM_BUILDER_HISTORY_SELECTED",

    moveNode = "ALBUM_BUILDER_MOVE_NODE",
    resizeNode = "ALBUM_BUILDER_RESIZE_NODE",
    rotateImage = "ALBUM_BUILDER_ROTATE_IMAGE",
    setNodeOpacity = "ALBUM_BUILDER_SET_NODE_OPACITY",
    updateNodeStyle = "ALBUM_BUILDER_UPDATE_NODE_STYLE",
    updateCrop = "ALBUM_BUILDER_UPDATE_CROP",
    changeAsset = "ALBUM_BUILDER_CHANGE_ASSET",
    reorderNodes = "ALBUM_BUILDER_REORDER_NODES",
    setBackgroundColor = "ALBUM_BUILDER_SET_BACKGROUND_COLOR",
    setBackgroundAsset = "ALBUM_BUILDER_SET_BACKGROUND_ASSET",
    setBackgroundOpacity = "ALBUM_BUILDER_SET_BACKGROUND_OPACITY",

    setActivePage = "ALBUM_BUILDER_SET_ACTIVE_PAGE",
    setSelectedNode = "ALBUM_BUILDER_SET_SELECTED_NODE",
    setRenderMode = "ALBUM_BUILDER_SET_RENDER_MODE",

    setPageLoading = "ALBUM_BUILDER_SET_PAGE_LOADING",
    setPageLoaded = "ALBUM_BUILDER_SET_PAGE_LOADED",
    setPageLoadError = "ALBUM_BUILDER_SET_PAGE_ERROR",
    loadPage = "ALBUM_BUILDER_LOAD_PAGE",
    loadAlbumPage = "ALBUM_BUILDER_LOAD_ALBUM_PAGE",
    unloadPage = "ALBUM_BUILDER_UNLOAD_PAGE",
    applyPages = "ALBUM_BUILDER_APPLY_PAGES",

    reset = "ALBUM_BUILDER_RESET",

    addGrid = "ALBUM_BUILDER_ADD_GRID",
    splitSlotV = "ALBUM_BUILDER_SPLIT_SLOT_V",
    splitSlotH = "ALBUM_BUILDER_SPLIT_SLOT_H",

    renameSheet = "ALBUM_BUILDER_RENAME_SHEET",

    saveRequest = "ALBUM_BUILDER_SAVE_REQUEST",
    saveSuccess = "ALBUM_BUILDER_SAVE_SUCCESS",
    saveFailure = "ALBUM_BUILDER_SAVE_FAILURE",

    saveTemplateRequest = "ALBUM_BUILDER_SAVE_ALBUM_REQUEST",
    saveTemplateSuccess = "ALBUM_BUILDER_SAVE_ALBUM_SUCCESS",
    saveTemplateFailure = "ALBUM_BUILDER_SAVE_ALBUM_FAILURE",

    markDirty = "ALBUM_BUILDER_MARK_DIRTY",
    markClean = "ALBUM_BUILDER_MARK_CLEAN",

    applyHistorySnapshot = "ALBUM_BUILDER_APPLY_HISTORY_SNAPSHOT",

    copySlotImages = "ALBUM_BUILDER_COPY_SLOT_IMAGES",
    cutSlotImages = "ALBUM_BUILDER_CUT_SLOT_IMAGES",
    pasteSlotImages = "ALBUM_BUILDER_PASTE_SLOT_IMAGES",
    swapSlotImages = "ALBUM_BUILDER_SWAP_SLOT_IMAGES",
    deleteSlot = "ALBUM_BUILDER_DELETE_SLOT",
    resizeSiblingSlots = "ALBUM_BUILDER_RESIZE_SIBLING_SLOTS",
    expandSlot = "ALBUM_BUILDER_EXPAND_SLOT",

    createBackgroundSasSuccess = "CREATE_BACKGROUND_SAS_SUCCESS",
    createBackgroundSasRequest = "CREATE_BACKGROUND_SAS_REQUEST",
    createAlbumBackgroundSasRequest = "CREATE_ALBUM_BACKGROUND_SAS_REQUEST",
    createBackgroundSasFailure = "CREATE_BACKGROUND_SAS_FAILURE",

    fetchAlbumSuccess = "FETCH_ALBUM_SUCCESS",
    fetchAlbumRequest = "FETCH_ALBUM_REQUEST",
    fetchAlbumFailure = "FETCH_ALBUM_FAILURE",

    fetchAlbumPageSuccess = "FETCH_ALBUM_PAGE_SUCCESS",
    fetchAlbumPageRequest = "FETCH_ALBUM_PAGE_REQUEST",
    fetchAlbumPageFailure = "FETCH_ALBUM_PAGE_FAILURE",

    fetchAlbumPagesRequest = 'ALBUM_BUILDER_FETCH_PAGES_REQUEST',
    fetchAlbumPagesSuccess = 'ALBUM_BUILDER_FETCH_PAGES_SUCCESS',
    fetchAlbumPagesFailure = 'ALBUM_BUILDER_FETCH_PAGES_FAILURE',

    updateAlbumSuccess = "UPDATE_ALBUM_SUCCESS",
    updateAlbumRequest = "UPDATE_ALBUM_REQUEST",
    updateAlbumFailure = "UPDATE_ALBUM_FAILURE",

    createAlbumPageRequest = "CREATE_ALBUM_PAGE_REQUEST",
    createAlbumPageSuccess = "CREATE_ALBUM_PAGE_SUCCESS",
    createAlbumPageFailure = "CREATE_ALBUM_PAGE_FAILURE",

    deleteAlbumPageRequest = "DELETE_ALBUM_PAGE_REQUEST",
    deleteAlbumPageSuccess = "DELETE_ALBUM_PAGE_SUCCESS",
    deleteAlbumPageFailure = "DELETE_ALBUM_PAGE_FAILURE",

    saveAlbumRequest = "SAVE_ALBUM_REQUEST",

    saveAlbumPageRequest = "SAVE_ALBUM_PAGE_REQUEST",

    getAlumBackgroundRequest = "GET_ALBUM_BACKGROUND_REQUEST",
    getAlumBackgroundSuccess = "GET_ALBUM_BACKGROUND_SUCCESS",
    getAlumBackgroundFailure = "GET_ALBUM_BACKGROUND_FAILURE",

    setVisiblePageIds = "ALBUM_BUILDER_SET_VISIBLE_PAGE_IDS",

    preparePreviewRequest =  "ALBUM_BUILDER_PREPARE_PREVIEW_REQUEST",
    preparePreviewPagesReady = "ALBUM_BUILDER_PREPARE_PREVIEW_PAGES_READY",
    preparePreviewReady = "ALBUM_BUILDER_PREPARE_PREVIEW_READY",
    preparePreviewFailure = "ALBUM_BUILDER_PREPARE_PREVIEW_FAILURE",
    clearPreviewState =  "ALBUM_BUILDER_CLEAR_PREVIEW_STATE",
}
